exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#task-details-drawer,\n#task-board-details-drawer {\n  background: transparent;\n}\n#task-details-drawer.drawer-no-backdrop,\n#task-board-details-drawer.drawer-no-backdrop,\n#task-details-drawer,\n#task-board-details-drawer {\n  background: transparent;\n}\n#task-details-drawer .drawer-panel,\n#task-board-details-drawer .drawer-panel {\n  background: #ffffff;\n  box-shadow: -12px 0 32px rgba(16, 24, 40, 0.12);\n}\n#task-details-drawer .drawer-body,\n#task-board-details-drawer .drawer-body {\n  padding: 0;\n  background: transparent;\n}\n", ""]);

// exports
